/**
 * The table view for the editor preview.
 *
 * Mirrors ChartRenderer::data_table(). Not a fallback — the chart's equivalent.
 * Three of the light palette's slots sit below 3:1 against white, and a tooltip
 * must never be the only way to read a value; the table answers both.
 */

import { __ } from '@wordpress/i18n';
import { formatShare, formatValue } from './format';

export default function DataTable( { config } ) {
	const radial = config.isRadial;
	const series = config.series[ 0 ];
	const total = radial
		? series.data.reduce( ( sum, value ) => sum + Math.max( 0, value ), 0 )
		: 0;

	return (
		<details className="brandy-chart__data">
			<summary className="brandy-chart__data-toggle">
				{ config.tableLabel }
			</summary>
			<div className="brandy-chart__data-scroll">
				<table className="brandy-chart__table">
					<thead>
						<tr>
							<th scope="col">{ config.categoryHead }</th>
							{ radial ? (
								<>
									<th scope="col">
										{ series.label ||
											__( 'Value', 'brandy-blocks' ) }
									</th>
									<th scope="col">
										{ __( 'Share', 'brandy-blocks' ) }
									</th>
								</>
							) : (
								config.series.map( ( one, index ) => (
									<th key={ index } scope="col">
										{ one.label }
									</th>
								) )
							) }
						</tr>
					</thead>
					<tbody>
						{ config.categories.map( ( category, index ) => (
							<tr key={ index }>
								<th scope="row">{ category }</th>
								{ radial ? (
									<>
										<td>
											{ formatValue(
												series.data[ index ] ?? 0,
												config.format
											) }
										</td>
										<td>
											{ total
												? formatShare(
														Math.max(
															0,
															series.data[
																index
															] ?? 0
														) / total
												  )
												: '—' }
										</td>
									</>
								) : (
									config.series.map( ( one, slot ) => (
										<td key={ slot }>
											{ formatValue(
												one.data[ index ] ?? 0,
												config.format
											) }
										</td>
									) )
								) }
							</tr>
						) ) }
					</tbody>
				</table>
			</div>
		</details>
	);
}
